import _defineProperty from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import Event from './Event';
import { allEvents } from './index';
import utils from './Util';

var Store =
/*#__PURE__*/
function () {
  function Store() {
    _classCallCheck(this, Store);

    utils.debug("v2/Store:constructor");
    this.events = [];
  }
  /**
   * Create and Add a new Event to this store Events list
   * @param eventName The event Name
   * @param transformers the transformers functions
   * @throws an Error if there is already an event with the same name
   */


  _createClass(Store, [{
    key: "addEvent",
    value: function addEvent(eventName) {
      utils.debug("v2/Store:addEvent");
      var validateEventName = utils.validateText(eventName); //Check for duplicated names on the Store

      this.events.forEach(function (event) {
        if (event.name === validateEventName) {
          throw new Error("STORE: An event named: ".concat(validateEventName, " already exists on the Store"));
        }
      });
      var e;

      for (var _len = arguments.length, transformers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        transformers[_key - 1] = arguments[_key];
      }

      if (transformers.length > 0) e = new Event(eventName, transformers);else e = new Event(eventName);
      this.events.push(e);
      allEvents.push(e);
    }
    /**
     * Subscribe to an Event to receive their updates
     * @param eventName The Event Name to which you want to subscribe
     * @param subscriber The subscriber function that's gonna be executed when it happends
     * @param receiveLastValue Whether the subscriber
     * @return subscription The subscription for this event in the Store
     * @throws an Error if the event does not exists
     * @throws an Error if the subscriber is not a function
     */

  }, {
    key: "subscribe",
    value: function subscribe(eventName, subscriber) {
      var receiveLastValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      utils.debug("v2/Store:subscribe");
      var validatedEventName = utils.validateText(eventName);
      if (typeof subscriber !== "function") throw new Error("subscriber must be a function");

      for (var i = 0; i < this.events.length; i++) {
        var event = this.events[i];

        if (event.name === validatedEventName) {
          var subscription = event.subscribe(subscriber);
          if (receiveLastValue) subscriber(event.value);
          return subscription;
        }
      }

      throw new Error("Non existent eventName: ".concat(validatedEventName, " on Store"));
    }
    /**
     * Get the state of the Store
     * This is the last know value of each event
     */

  }, {
    key: "getState",
    value: function getState(eventName) {
      utils.debug("v2/Store:getState");
      if (!(eventName === undefined || eventName === null)) return this.__getEventState(eventName);
      var state = {};
      this.events.forEach(function (event) {
        var eventState = event.value;
        var eventName = event.name;
        state = Object.assign(state, _defineProperty({}, eventName, eventState));
      });
      return state;
    }
    /**
     * Get the state of a particular event
     * This is the last know value of the event
     */

  }, {
    key: "__getEventState",
    value: function __getEventState(eventName) {
      utils.debug("v2/Store:__getEventState");

      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].name === eventName) return this.events[i].value;
      }

      throw new Error("Non existent eventName: ".concat(eventName, " on Store"));
    }
    /**
     * Clears all the values of the events in the Store
     */

  }, {
    key: "clearState",
    value: function clearState() {
      utils.debug("v2/Store:clearState");
      this.events.forEach(function (event) {
        return event.value = null;
      });
    }
  }]);

  return Store;
}();

export default Store;